export enum BookingKitEventType {
  Comment = "Comment",
  SystemLog = "SystemLog"
}
